import "./LandingPageStyle.scss";
import { IJSLComponent, IJSLVNode } from "jsl-render";
import { EPCSOLandingForm } from "../../ajax/types/EPCSOLandingForm";
import { GarantieComponent } from "./GarantieComponent";
import { ErrorComponent } from "../common/ErrorComponent";
import { StartersetComponent } from "./StartersetComponent";
import { WertGarantieComponent } from "./WertGarantieComponent";
import { WertGarantieComponent2025 } from './deprecated/WertGarantieComponent';

export class LandingPageComponent implements IJSLComponent {

  private actualForm: IJSLComponent;

  public constructor(private options: EPCSOLandingForm) {
    switch (options.Type) {
      case "garantie": {
        this.actualForm = new GarantieComponent(options);
      } break;
      case  "wert": {
        if (options.Name === "wertgarantie25") {
        this.actualForm = new WertGarantieComponent2025(options);
        } else {
        this.actualForm = new WertGarantieComponent(options);
        }
      } break;
      case "starterset": {
        this.actualForm = new StartersetComponent(options);
      } break;
      default: this.actualForm = new ErrorComponent("Unbekannte Formular Art");
    }
    // if (options.Type === "garantie") {
    //   this.actualForm = new GarantieComponent(options);
    // } else if (options.Type === "wert") {
    //   this.actualForm = new GarantieComponent(options); // TODO
    // } else if (options.Type === "starterset") {
    //   this.actualForm = new StartersetComponent(options);
    // } else {
    //   this.actualForm = new ErrorComponent("Unbekannte Formular Art");
    // }
  }

  public render(): IJSLVNode {
    return <div class="landing-page-comp">
      <h1>{this.options.Title}</h1>
      {{ tag: "div", content: this.options.TextAsHTML, raw: true }}
      {this.actualForm}
    </div>;
  }

}